import { Chart as ChartJS } from "chart.js"

// types
import { ThemeMode } from "types/config"

declare global {
  interface Window {
    Apex?: Record<string, any>
  }
}

const LIGHT_CHART_TEXT = "#666"
const LIGHT_CHART_BORDER = "rgba(0, 0, 0, 0.1)"
const DARK_CHART_TEXT = "#B3B3B3"
const DARK_CHART_BORDER = "rgba(255, 255, 255, 0.1)"

// Most pages colour things with inline styles and Tailwind classes instead of the MUI palette,
// so besides the MUI theme the document itself carries the mode: the `dark` class drives
// Tailwind `dark:` variants and styles/dark-mode.css; charts read their global defaults.
const applyDocumentThemeMode = (mode: ThemeMode) => {
  const isDark = mode === ThemeMode.DARK
  const root = document.documentElement

  root.classList.toggle("dark", isDark)
  root.style.colorScheme = isDark ? "dark" : "light"

  ChartJS.defaults.color = isDark ? DARK_CHART_TEXT : LIGHT_CHART_TEXT
  ChartJS.defaults.borderColor = isDark ? DARK_CHART_BORDER : LIGHT_CHART_BORDER

  window.Apex = {
    ...window.Apex,
    chart: { ...window.Apex?.chart, foreColor: isDark ? DARK_CHART_TEXT : "#373d3f" },
    grid: { ...window.Apex?.grid, borderColor: isDark ? DARK_CHART_BORDER : "#e0e0e0" },
    tooltip: { ...window.Apex?.tooltip, theme: isDark ? "dark" : "light" }
  }
}

// Chart.js draws on a canvas, which cannot read CSS variables; a scriptable option is evaluated
// on every draw, so a chart picks up the current mode without rebuilding its options
export const chartGridColor = (lightColor: string) => () =>
  document.documentElement.classList.contains("dark") ? DARK_CHART_BORDER : lightColor

export default applyDocumentThemeMode
